<template>
	<nk-page :commercialAccess="['Sale', 'Warehouse']" :policyClaims="['Product_Product_Management']" :buttons="[refreshButton]">
		<template #badges>
			<nk-badge system="sale">
				<nk-badge-item type="system" modelValue="sale"></nk-badge-item>
				<nk-badge-item type="system" modelValue="sale" :title="$t(`forms.Product_List`)"></nk-badge-item>
			</nk-badge>
		</template>
		<div class="d-flex flex-column h-100">
			<div class="row no-gutters mb-2">
				<nk-radio :group="'stock-type'" :tabindex="102" :options="componentOptions.radioWarehouse" v-model="stockType" />
				<nk-radio :group="'stock-type'" :tabindex="103" :options="componentOptions.radioFactor" v-model="stockType" />
				<nk-radio :group="'stock-type'" :tabindex="104" :options="componentOptions.radioAll" v-model="stockType" />
			</div>
			<div class="flex-grow-1">
				<ag-grid v-model="productListSelectedRow" :options="componentOptions.tableOptions" :data="filteredProductList" @row_db-clicked="rowDbClicked" ref="productListTable" startup tabindex="105"></ag-grid>
			</div>
		</div>
	</nk-page>
</template>
<script>
	import _ from 'lodash'
	import { post } from '~/plugins/nikan-api'
	import ProductModify from './product-modify'
	import $sc from '~/plugins/shortcut.collection.js'
	import { isEmpty } from '~/statics/validators'
	import Endpoints from '@nikan/endpoints'
	import BooleanLabel from '~/components/form/boolean-label'
	import dialog from '~/plugins/nikan-dialog-plugin'
	import { mapGetters, mapActions } from 'vuex'
	import emptyId from '~/statics/empty-id'
	import { PrintDataConvertTypes } from '@/plugins/stimul'
	import ProductAdvanceName from '@/components/form/product/product-advance-name.vue'

	const StockTypes = {
		ALL: 'All',
		FACTOR: 'Factor',
		WAREHOUSE: 'Warehouse'
	}

	const stateKey = 'other_productListStockType'

	export default {
		name: 'product-list',
		modal: {
			size: 'lg',
			stateUID: 'product-list',
			helpTag: 'ProductList'
		},
		props: {
			data: { type: Object },
			options: {},
		},
		data() {
			return {
				settings: {
					mode: 'select',
					allowMultiple: false,
					includeFloatingJsons: false,
					includeProductUnits: false,
					includeSalePoints: false,
					includePrices: false,
					includeBarcodes: true,
					includeDisableProducts: true
				},
				stockType: null,
				productList: [],
				productListSelectedRow: null,
				componentOptions: {
					radioAll: {
						title: this.$t('sale.product.list.filter-all'),
						color: 'purple',
						value: StockTypes.ALL,
					},
					radioFactor: {
						title: this.$t('sale.product.list.filter-byFactor'),
						color: 'purple',
						value: StockTypes.FACTOR,
					},
					radioWarehouse: {
						title: this.$t('sale.product.list.filter-byWarehouse'),
						color: 'purple',
						value: StockTypes.WAREHOUSE,
					},
					tableOptions: {
						id: this.$options.name,
						focusAndSelect: {
							allowFocus: true
						},
						doubleClickedToSelect: true,
						enterToSelect: true,
						rowGroupPanelShow: false,
						groupIncludeTotalFooter: false,
						cellSelectionAggReport: false,
						pagination: false,
						fitToWidth: false,
						sideBar: 'none',
						rowSelection: {
							mode: 'multiRow',
							checkboxes: true,
							headerCheckbox: true
						},
						columnDefs: [
							{
								field: 'rowNumber',
								headerName: this.$t('row-number'),
								width: 50,
							},
							{
								field: 'code',
								headerName: this.$t('sale.product.f.code'),
								width: 100,
								contentType: 'number'
							},
							{
								field: 'name',
								headerName: this.$t('sale.product.f.name'),
								contentType: 'string',
								cellRenderer: ProductAdvanceName,
								cellRendererSelector: (params) => {
									return params.data.$__isAggregateRow ? ProductAdvanceName : undefined
								},
								cellRendererParams: (params) => {
									if (params.data)
										return {
											options: {
												data: {
													id: params.data.id,
													code: params.data.code,
													name: params.value,
													imageUrl: params.data.imageUrl,
												},
												advance: true,
												hideBalance: true
											}
										}
								},
							},
							{
								field: 'productGroup',
								headerName: this.$t('sale.product.f.productGroup'),
								width: 100,
								contentType: 'enum',
								valueFormatter: data => data.value.name,
							},
							{
								field: 'kind',
								headerName: this.$t('sale.product.f.kind'),
								contentType: 'enum',
								valueFormatter: data => this.$t('ProductKindes.' + data.value.toLowerCase()),
								width: 130,
							},
							{
								field: 'technicalNumber',
								headerName: this.$t('sale.product.f.technicalNumber'),
								width: 130,
								contentType: 'string',
							},
							{
								field: 'lastStockOnReceiptHawala',
								headerName: this.$t('sale.product.f.lastStockOnReceiptHawala'),
								width: 250,
								contentType: 'number',
							},
							// {
							// 	field: 'isEnabled',
							// 	headerName: this.$t('sale.product.f.isEnabled'),
							// 	contentType: 'enum',
							// 	valueFormatter: data => data.value ? 'بله' : 'خیر',
							// 	cellRenderer: BooleanLabel,
							// 	cellRendererParams: (data) => {
							// 		return {
							// 			options: {
							// 				useColors: true,
							// 				modelValue: data.value
							// 			},
							// 		}
							// 	},
							// 	width: 130,
							// },
							// {
							// 	field: 'isTaxFree',
							// 	headerName: this.$t('sale.product.f.isTaxFree'),
							// 	contentType: 'enum',
							// 	valueFormatter: data => data.value ? 'بله' : 'خیر',
							// 	cellRenderer: BooleanLabel,
							// 	cellRendererParams: (data) => {
							// 		return {
							// 			options: {
							// 				useColors: true,
							// 				modelValue: data.value
							//
							// 			},
							// 		}
							// 	},
							// 	width: 130,
							// },
							// {
							// 	field: 'isTollFree',
							// 	headerName: this.$t('sale.product.f.isTollFree'),
							// 	searchable: true,
							// 	contentType: 'enum',
							// 	valueFormatter: data => data.value ? 'بله' : 'خیر',
							// 	cellRenderer: BooleanLabel,
							// 	cellRendererParams: (data) => {
							// 		return {
							// 			options: {
							// 				useColors: true,
							// 				modelValue: data.value
							//
							// 			},
							// 		}
							// 	},
							// 	width: 130,
							// },
							// {
							// 	field: 'isSerialized',
							// 	headerName: this.$t('sale.product.f.isSerialized'),
							// 	searchable: true,
							// 	contentType: 'enum',
							// 	valueFormatter: data => data.value ? 'بله' : 'خیر',
							// 	cellRenderer: BooleanLabel,
							// 	cellRendererParams: (data) => {
							// 		return {
							// 			options: {
							// 				useColors: true,
							// 				modelValue: data.value
							//
							// 			},
							// 		}
							// 	},
							// 	width: 130,
							// },
							// {
							// 	field: 'defaultWarehouse',
							// 	headerName: this.$t('sale.product.f.defaultWarehouse'),
							// 	contentType: 'enum',
							// 	valueFormatter: data => data.value?.name,
							//
							// },
						],

					},
				},
				insertProductButton: {
					title: this.$t('sale.product.insert'),
					shortcut: $sc.find('insert'),
					isPrimary: false,
					icon: 'plus',
					handle: (button, page, e) => {
						this.showModifyProduct(null)
					},
					policyClaims: 'Product_Product_Add',
				},
				refreshButton: {
					title: this.$t('trs.chq.oper.refresh'),
					icon: 'sync',
					handle: () => {
						this.getProductListData()
					},
				},
				editProductButton: {
					title: this.$t('sale.product.edit'),
					shortcut: $sc.find('edit'),
					visible: true,
					icon: 'edit',
					handle: (button, page, e) => {
						e.preventDefault()
						if (this.productListSelectedRow.length !== 1)
							return this.$toast(this.$t('sale.product.m.select-one-product'), { type: 'info' })

						this.showModifyProduct(this.productListSelectedRow)
					},
					policyClaims: 'Product_Product_Edit',
				},
				deleteProductButton: {
					title: this.$t('sale.product.delete'),
					shortcut: $sc.find('delete'),
					visible: true,
					icon: 'trash',
					handle: (button, page, e) => {
						e.preventDefault()
						if (!this.productListSelectedRow.length)
							return this.$toast(this.$t('sale.product.m.no-product-selected'), { type: 'info' })

						this.showDeleteProductDialog(this.productListSelectedRow)
					},
					policyClaims: 'Product_Product_Delete',
				},
				excelButton: {
					type: 'excel',
					module: 'sale',
					mapSettings: { type: 'Product', successHandler: this.getProductListData },
					exportIds: () => this.productListSelectedRow ? this.productListSelectedRow.map(x => x.id) : [emptyId],
				},
				printButton: {
					type: 'print',
					claimPrefix: 'Product_Product_Management',
					form: 'ProductList',
					getDataSources: this.print_dataSources,
					disabled: false,
				},
				selectProductButton: {
					title: this.$t('select'),
					shortcut: $sc.find('enter'),
					element: () => this.$refs.productListTable.$el,
					icon: 'check',
					isPrimary: true,
					handle: (button, page, e) => {
						if (this.productListSelectedRow.length === 0 || (!this.settings.allowMultiple && this.productListSelectedRow.length > 1))
							return this.$toast(this.$t('sale.product.m.select-one-product'), { type: 'info' })

						this.resolve(this.settings.allowMultiple ? this.productListSelectedRow : this.productListSelectedRow[0])
					},
					policyClaims: 'Product_Product_Management',
				},
				gParent: null
			}
		},
		watch: {
			options: {
				handler(val, OldVal) {
					this.settings = _.extend({}, this.settings, val)
				},
				deep: true,
			},
			stockType: {
				handler(val, OldVal) {
					if (!OldVal)
						return
					let state = this.getActiveStateByKey(stateKey)
					if (state) {
						state.rowState = 'changed'
						state.value.val = val
					} else {
						state = {
							id: emptyId,
							key: stateKey,
							name: this.$t('sale.product.list.appState-title.'),
							rowState: 'new',
							value: { val: val },
							isActive: true
						}
					}
					this.modifyStates([state])
					this.syncStates()
				},
			},
		},
		computed: {
			...mapGetters({
				getActiveStateByKey: 'appStates/getActiveByKey',
			}),
			filteredProductList() {
				if (this.stockType === StockTypes.FACTOR)
					return this.productList.filter(x => x.lastStockOnFactor > 0 || x.kind === 'Service')
				else if (this.stockType === StockTypes.WAREHOUSE)
					return this.productList.filter(x => x.lastStockOnReceiptHawala > 0 || x.kind === 'Service')

				return this.productList
			}
		},
		created() {
			this.settings = _.extend({}, this.settings, this.options)
		},
		mounted() {
			let buttonsArray
			this.gParent = this.grandParentType()
			if (this.gParent === 'modal') {
				buttonsArray = [this.selectProductButton]
			} else {
				this.selectProductButton.visible = false
				buttonsArray = [
					this.selectProductButton,
					this.insertProductButton,
					this.editProductButton,
					this.deleteProductButton,
					{ type: 'seprator' },
					this.excelButton,
					this.printButton
				]
			}
			this.prepareStockType()
			this.prepareWindow(this.$t('sale.product-list.title'), buttonsArray)

			this.productListSelectedRow = this.data ? [this.data] : null
			this.getProductListData()
		},
		methods: {
			...mapActions({
				modifyStates: 'appStates/modify',
				syncStates: 'appStates/sync',
			}),
			prepareStockType() {
				let state = this.getActiveStateByKey('other_productListStockType')
				this.stockType = state?.value?.val || StockTypes.ALL
			},
			getProductListData() {
				var url = Endpoints.getUrl('sale.product.list')
				var wait = this.$wait(this.$refs.productListTable.$el)
				return post(url, {
					includeFloatingJsons: this.settings.includeFloatingJsons,
					includeProductUnits: this.settings.includeProductUnits,
					includeSalePoints: this.settings.includeSalePoints,
					includePrices: this.settings.includePrices,
					includeBarcodes: this.settings.includeBarcodes,
					includeDisableProducts: this.settings.includeDisableProducts
				})
					.then((result) => {
						wait.end()
						this.productList = result.data.items
						this.productListSelectedRow = this.data ? [this.data] : null
						this.tableOptions.focusAndSelect.update = !this.tableOptions.focusAndSelect.update
					})
					.catch(() => {
						wait.end()
					})
			},
			showModifyProduct(productInfo) {
				if (productInfo !== null && productInfo.length !== 1)
					return this.$toast(this.$t('sale.product.m.select-one-product'), { type: 'info' })

				const id = productInfo ? productInfo[0].id : null

				this.showModal({ component: ProductModify, options: { id: id } })
					.then((response) => {
						this.getProductListData().then(() => {
							this.$refs.productListTable.read()
							this.$refs.productListTable.$el.focus()
						})
					})
					.catch(() => {
						//this.getProductListData()
						this.$refs.productListTable.$el.focus()
					})
			},
			showDeleteProductDialog(productInfo) {
				dialog({
					title: this.$t('sale.product.delete'),
					body: this.$t('sale.product.m.want-to-delete-products', {
						count: productInfo.length,
					}),
					type: 'warning',
					autoClose: true,
					buttons: [
						{
							title: this.$t('dialog.yes'),
							shortcut: $sc.find('yes', 'dialog'),
							isPrimary: true,
							handle: (button, page, e) => {
								this.deleteProduct(productInfo)
							},
						},
						{
							title: this.$t('dialog.cancel'),
							shortcut: $sc.find('cancel', 'dialog'),
							isCancel: true,
							handle: (button, page, e) => { },
						},
					],
				})
			},
			deleteProduct(product) {
				var wait = this.$wait(this.$refs.productListTable, { size: 'small' })
				post(Endpoints.getUrl('sale.product.bulkDelete'), { Ids: product.map(x => x.id) })
					.then((result) => {
						wait.end()
						this.$toast(this.$t('msg.delete-success'), { type: 'success' })
						this.getProductListData()
					})
					.catch(() => {
						wait.end()
					})
			},
			print_dataSources() {
				const data = this.$refs.productListTable.getFilteredTableData()

				return [
					{
						name: 'Product',
						data: data,
						translatedDataSetName: this.$t('nav.product'),
						translatePrefix: 'sale.product.f',
						converter: {
							type: PrintDataConvertTypes.MAPPER,
							settings: {
								code: 'code',
								name: 'name',
								nameAlternate: 'nameAlternate',
								technicalNumber: 'technicalNumber',
								trackingNumber: 'trackingNumber',
								productGroup: (item) => item?.name || '',
								productClassification: (item) => item?.name || '',
								kind: (item) => this.$t(`ProductKindes.${item.toLowerCase()}`),
								barcode: (item, row) => row.barcodes?.[0]?.code || '',
								barcodes: {
									barcodeCode: (item, row) => row.code,
									codeType: (item, row) => this.$t(`enum-items.CodeTypes.${item}`),
								},
								lastStockOnFactor: 'lastStockOnFactor',
								lastStockOnReceiptHawala: 'lastStockOnReceiptHawala',
							}
						},
					}
				]
			},
			rowDbClicked(val) {
				if (this.gParent === 'modal')
					this.resolve(val)
			}
		},
	}
</script>
<style></style>
